// dilip 01/12/2023 2699714747 Added Map Exception Records Step.
// dilip 01/12/2023 2699714747 Fixed message and status reset issue.
// dilip 01/12/2023 2699714747 Fixed Parent record going issue in payload in the Map Fileds step.
// dilip 01/16/2023 2699714747 Added GET data API call after map exception save.
// dilip 01/16/2023 2699714747 Fixed Draft status issue.
// dilip 01/20/2023 2699714747 Added Map Exception functionality for IM Record Group
// dilip 01/20/2023 2699714747 Added Last Step functionality
// Sohel 02/06/2023 2698964415 enable Save and Finish button
// suresh peddavoora 02/24/2023 2699714747 New UI changes
// Sohel 03/02/2023 2698964415 hide Footer And header button
// Sohel 03/03/2023 2698964415 hide Footer And header button
// Sohel 02/03/2023 2698964415 hide Footer And header button
// Ravi 03/08/2023 2698964415 rename Error Record to Custom Error
// Sohel 03/13/2023 2698964415 Import Manager Added Default Error Button
// Sohel 03/20/2023 2698964415 change payload
// Sohel 03/30/2023 2698964415 default Error payload Changes
// Sohel 04/06/2023 2698964415 default Error payload Changes
// Akhila 04/17/2023 2698964415 modified in payload for defaultErrorFlag conditonaly
// Sohel 04/06/2023 2698964415 Sub Record Type Value Changes
// Akhila 05/31/2023 2698964415 unsaved changes bug fixed
// Akhila 06/12/2023 2698964415 added role access
// Sohel 06/19/2023 3075154998 Enable Save Button
// Ravi 06/19/2023 2698964415 Added Breadcrum in popup
// Ravi 06/23/2023 2698964415 fixed submit issue
// Sohel 11/29/2023 2698964415 Custom Error button Header Changes.
import React, {useState, useEffect, useRef} from 'react';
import {Button, Tooltip} from '@material-ui/core';
import {useSelector, useDispatch} from 'react-redux';
import reusableInputStyles from '../../../../../components/InputStyles';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {
  postMapRecordInfo,
  getExceptionRecordMapData,
  resetMsgAndStatus,
} from '../../../../../redux/reducers/DataManager';
import SearchRecords from '../../../DataManager/DataManagerRecord/SearchDataManagerRecord';
import DialogBox from './../../../../../components/DialogBox/index';
import MappedRecordsTable from './MappedRecordTable';
import BreadCrums from '../../../../../util/BreadCrum';
import AddIcon from '@material-ui/icons/Add';
import {Form, Formik} from 'formik';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const MapRecordGroup = ({
  labelChanges,
  handleBack,
  exportManager,
  handleDirty,
  handleNext,
  setValue,
  hidden,
  editExisting,
  DataManagerAccess,
}) => {
  const classes = reusableInputStyles();
  const [open, setOpen] = useState(false);
  const saveRef = useRef();
  const recordTypeRef = useRef('');
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [records, setRecords] = useState([]);
  const [defaultError, setDefaultError] = useState(false);
  const dispatch = useDispatch();
  const initialValues = {
    recordsLength: 0,
  };
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const disabledCustomError = (type) => {
    return records?.filter((item) => item?.recordCode === type)?.length >= 1;
  };
  const disabledDefaultError = (type) => {
    return records?.filter((item) => item?.subRecordType === type)?.length >= 1;
  };
  const {
    isBasicInfoLoading,
    basicInfoErrorMsg,
    basicInfoSuccessMsg,
    basicInfoData,
    recordsExceptionData,
    mappedExcRecordsStatus,
    parentRecordException,
    defaultErrorFlag,
  } = useSelector(({dataManagerGroup}) => dataManagerGroup);
  useEffect(() => {
    if (basicInfoData?.dmCode) {
      dispatch(getExceptionRecordMapData(basicInfoData?.dataManagerId));
    }
  }, [basicInfoData]);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  useEffect(() => {
    if (basicInfoData?.dmCode && mappedExcRecordsStatus === 200 && saveRef.current) {
      dispatch(getExceptionRecordMapData(basicInfoData?.dataManagerId));
    }
  }, [mappedExcRecordsStatus]);

  useEffect(() => () => dispatch(resetMsgAndStatus()), []);

  const isMultiRecordFormat =
    basicInfoData?.multiRecordFormat === 'Yes' || basicInfoData?.multiRecordFormat === 'Y';
  useEffect(() => {
    if (recordsExceptionData?.length > 0) {
      const data = recordsExceptionData?.length > 0 ? recordsExceptionData?.map(el =>{
        return {
          ...el,
          dataManagerRecordId:!isMultiRecordFormat && el?.recordId ?  el?.recordId :0,
          dmRecordGroupId:isMultiRecordFormat && el?.recordId ? el?.recordId:0, 
        }
      }):[];
      setRecords(data);
    }
  }, [recordsExceptionData]);

  useEffect(() => {
    if (basicInfoErrorMsg || basicInfoSuccessMsg) {
      setTimeout(() => {
        if (mappedExcRecordsStatus === 200 && basicInfoSuccessMsg && !saveRef.current) {
          setValue(0);
        }
        dispatch(resetMsgAndStatus());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);

  const handleClose = () => {
    setOpen(false);
  };
  const handleSubmit = (values) => {
    const obj = {};
    const obj2 = {};
    recordsExceptionData?.forEach((row) => {
      obj[row?.recordCode] = row?.recordMapId;
      obj2[row?.recordCode] = row?.recordMapId;
    });
    records?.forEach((row2) => {
      if (obj[row2?.recordCode]) {
        delete obj[row2?.recordCode];
      }
    });
    if (basicInfoData?.dmCode) {
      dispatch(submissionStart());
      const recordsArr = records.map((el) => {
        const existingIds = obj2[el.recordCode] ? obj2[el.recordCode] : null;
        return {
          recordCode: el.recordCode,
          recordDescription: el.recordDescription,
          recordMapId: el?.recordMapId ? el?.recordMapId : existingIds ? existingIds : 0,
          recordType: el.recordType,
          subRecordType: el.subRecordType,
          recordId: !isMultiRecordFormat && el?.dataManagerRecordId ? el?.dataManagerRecordId : isMultiRecordFormat && el?.dmRecordGroupId ? el?.dmRecordGroupId: 0,
        };
      });
      const customError = records?.length > 0 ? true : false;
      const payload = {
        dataManagerId: basicInfoData?.dataManagerId ? basicInfoData?.dataManagerId : 0,
        fileType: 'Import',
        defaultErrorFlag: defaultError ? 'Y' : customError ? 'N' : null,
        recordMapRequests: defaultError ? [] : recordsArr,
        dmCode: basicInfoData?.dmCode,
        mapType: isMultiRecordFormat ? 'Record Groups' : '',
        deleteIds: Object.values(obj).length > 0 ? Object.values(obj) : [0],
        lastStep: 2,
        isDraft: ['New Account Import', 'New Payment Import', 'Data Update']?.includes(
          basicInfoData?.dmType,
        )
          ? 'N'
          : basicInfoData?.isDraft,
      };
      dispatch(postMapRecordInfo(payload, true));
    }
  };
  useEffect(() => {
    if (defaultError) {
      const data = [...records];
      data?.push({
        recordCode: 'Default_Error',
        recordDescription: 'Default_Error has been used',
      });
      setRecords(data);
    } else {
      setDefaultError(false);
    }
  }, [defaultError]);

  useEffect(() => {
    if (defaultErrorFlag === 'Y') {
      setDefaultError(true);
    } else {
      setDefaultError(false);
    }
  }, [defaultErrorFlag]);
  const disableFunction = (type) =>
    records.filter((item) => item.subRecordType === type)?.length >= 1;
  // handleDirty(!(records?.length === recordsExceptionData?.length));
  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
        validateOnChange
      >
        {(props) => {
          const {values} = props;
          return (
            <Form noValidate>
              <div className="d-flex col-12  new-standard-textfields">
                <div>
                  <BreadCrums
                    name={exportManager ? 'Export Manager Name' : 'Import Manager Name'}
                    code={basicInfoData?.dmCode}
                    description={
                      exportManager ? 'Export Manager Description' : 'Import Manager Description'
                    }
                    descriptionValue={basicInfoData?.dmDescription}
                    returnType={'Type'}
                    returnTypeValue={basicInfoData?.dmType || ''}
                  />
                </div>
              </div>
              <div className="table-header table-card-header justify-content-end new-standard-textfields">
                {isMultiRecordFormat && (
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot} mr-2`}
                    onClick={() => {
                      recordTypeRef.current = 'Exception Header';
                      setOpen(true);
                    }}
                    disabled={disableFunction('Exception Header')}
                    startIcon={<AddIcon />}
                  >
                    Header
                  </Button>
                )}
                {isMultiRecordFormat && (
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot} mr-2`}
                    disabled={disableFunction('Exception Footer')}
                    onClick={() => {
                      recordTypeRef.current = 'Exception Footer';
                      setOpen(true);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Footer
                  </Button>
                )}
                {!isMultiRecordFormat && (
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot} mr-2`}
                    disabled={
                      disabledCustomError('Default_Error') || disabledDefaultError('Error Record')
                    }
                    onClick={() => {
                      setDefaultError(true);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Default Error
                  </Button>
                )}
                <Button
                  variant="outlined"
                  className={`search-btn ${classes.buttonRoot} mr-2`}
                  disabled={!isMultiRecordFormat && disabledCustomError('Default_Error')}
                  onClick={() => {
                    recordTypeRef.current = 'Exception Record';
                    setOpen(true);
                  }}
                  startIcon={<AddIcon />}
                >
                  Custom Error
                </Button>
              </div>
              <MappedRecordsTable
                setRecords={setRecords}
                records={records}
                isMultiRecordFormat={false}
                showSubRecordType={true}
                defaultError={isMultiRecordFormat}
                setDefaultError={setDefaultError}
                handleDirty={handleDirty}
                editExisting={editExisting}
                DataManagerAccess={DataManagerAccess}
              />

              <DialogBox open={open} dialogClose={handleClose}
              //  title="Search Records"
                title={
                  <div className="dialog-breadcrum">
                    <p className="dialoge-title-breadcrum">
                      <b>Search Records</b>
                    </p>
                    <BreadCrums
                      name={
                        'Import Manager Code'
                      }
                      code={basicInfoData?.dmCode}
                      description={
                        'Import Manager Description'
                      }
                      descriptionValue={basicInfoData?.dmDescription}
                    />
                  </div>
                }
                maxWidth="xl">
                <SearchRecords
                  setRecords={setRecords}
                  records={records}
                  setTempSelectedRows={setTempSelectedRows}
                  tempSelectedRows={tempSelectedRows}
                  handleClose={handleClose}
                  recordGroupType={{value: 'Exception', subRecordType: recordTypeRef.current}}
                  dmTypeFromMap={exportManager ? 'Export' : 'Import'}
                  exportManagerRecordGroup={exportManager}
                  mapRecord={true}
                  parentRecordException={parentRecordException}
                />
              </DialogBox>

              <div className="d-flex justify-content-center mt-3 new-standard-textfields">
                <Button
                  variant="outlined"
                  onClick={() => {
                    handleBack();
                  }}
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Tooltip
                  title={
                    // records.filter((item) => item.subRecordType === "Error Record")?.length === 0
                    //   ? `Please add atleast one Error Record`
                    //   : ""
                    ''
                  }
                >
                  <span>
                    <Button
                      variant="outlined"
                      type="button"
                      className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                      // disabled={
                      //   records.filter((item) => item.subRecordType === "Error Record")
                      //     ?.length === 0
                      // }
                      disabled={(editExisting && !DataManagerAccess?.edit) || enabledSubmission}
                      onClick={() => {
                        saveRef.current = true;
                        handleDirty(false, 'fixed');
                        handleSubmit(values);
                      }}
                    >
                      Save
                    </Button>
                  </span>
                </Tooltip>
                {/* )} */}
                <Tooltip
                  title={
                    // records.filter((item) => item.subRecordType === "Error Record")?.length === 0
                    //   ? `Please add atleast one Error Record`
                    //   : ""
                    ''
                  }
                >
                  <span>
                    <Button
                      variant="outlined"
                      disabled={(editExisting && !DataManagerAccess?.edit) || enabledSubmission }
                      onClick={() => {
                        handleSubmit(values);
                        saveRef.current = false;
                      }}
                      // disabled={
                      //   records.filter((item) => item.subRecordType === "Error Record")?.length ===
                      //   0
                      // }
                      className={`search-btn ml-1 ${classes.buttonRoot}`}
                    >
                      Finish
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </Form>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
};

export default MapRecordGroup;
